import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiCheckCircle,
  FiExternalLink,
  FiLink,
} from "react-icons/fi";
import AccountNav from "./AccountNav";
import {
  customers,
  formatAccountDate,
  formatOrderAmount,
  orders,
} from "../Datas/accountData";
import siteConfig from "../config/siteConfig";
import "../css/account.scss";

function Orders() {
  useEffect(() => {
    document.title = `Orders — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="account-page">
      <div className="shell">
        <AccountNav />
        <header className="account-heading">
          <div>
            <p className="eyebrow">Account overview</p>
            <h1>Your orders</h1>
          </div>
          <p>Review order information, delivery details and tracking status.</p>
        </header>

        <section className="order-list" aria-label="Order list">
          <div className="order-list__head" aria-hidden="true">
            <span>Order</span>
            <span>Product</span>
            <span>Seller store</span>
            <span>Date</span>
            <span>Status</span>
            <span>Unit price</span>
            <span>Total</span>
            <span />
          </div>
          {orders.map((order) => {
            const seller = customers.find(
              (customer) => customer.id === order.sellerId
            );

            return (
              <article className="order-row" key={order.id}>
                <div className="order-row__primary">
                  <div>
                    <small>Order</small>
                    <strong>{order.id}</strong>
                    <p>Placed by {order.customer}</p>
                  </div>
                </div>
                <div className="order-row__product">
                  <img src={order.image} alt={order.product} />
                  <div>
                    <small>Product</small>
                    <strong>{order.product}</strong>
                    <p>{order.quantityLabel}</p>
                  </div>
                </div>
                <div className="order-row__seller">
                  <small>Seller store</small>
                  {seller ? (
                    <>
                      <Link to={`/customers/${seller.id}`}>{seller.name}</Link>
                      {seller.storeUrl ? (
                        <a
                          href={seller.storeUrl}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={`Visit ${seller.name} store`}
                        >
                          {seller.storeLabel || seller.storeUrl}{" "}
                          <FiExternalLink />
                        </a>
                      ) : (
                        <span>
                          <FiLink /> Link pending
                        </span>
                      )}
                    </>
                  ) : (
                    <span>Not assigned</span>
                  )}
                </div>
                <div className="order-row__field">
                  <small>Date</small>
                  <span>{formatAccountDate(order.issuedAt)}</span>
                </div>
                <div className="order-row__field">
                  <small>Status</small>
                  <span className="status-badge status-badge--success">
                    <FiCheckCircle /> {order.carrierStatus}
                  </span>
                </div>
                <div className="order-row__field order-row__unit-price">
                  <small>Unit price</small>
                  <span>{formatOrderAmount(order.unitPrice)}</span>
                </div>
                <div className="order-row__field order-row__total">
                  <small>Total</small>
                  <span>{formatOrderAmount(order.amount)}</span>
                </div>
                <Link
                  className="order-row__link"
                  to={`/orders/${order.id}`}
                  aria-label={`View ${order.id}`}
                >
                  View order <FiArrowRight />
                </Link>
              </article>
            );
          })}
        </section>

        <div className="account-support">
          <p>Need help with an order?</p>
          <Link to="/contact">
            Contact customer care <FiArrowRight />
          </Link>
        </div>
      </div>
    </main>
  );
}

export default Orders;
